import React from "react";
import Label from "components/shared/form/Label";
import useRegisterPropOrFromContext from "components/shared/form/fields/useRegisterPropOrFromContext";
import { UseFormRegister } from "react-hook-form";

type AddressFieldArgs = {
  name: string;
  required: {
    street: boolean;
    number: boolean;
    zip: boolean;
    city: boolean;
  };
  register?: UseFormRegister<any>;
};

export default function AddressField({ name, register }: AddressFieldArgs) {
  register = useRegisterPropOrFromContext(register);

  return (
    <div className="flex flex-col gap-2">
      <div className="control-group">
        <Label
          label={`${I18n.t("js.forms.address.street")} / ${I18n.t(
            "js.forms.address.number",
          )}`}
        />
        <div className="controls flex gap-2">
          <input
            type="text"
            pattern="[0-9]{5}(-[0-9]{4})?"
            maxLength={10}
            placeholder={I18n.t("js.forms.address.street")}
            aria-label={I18n.t("js.forms.address.street")}
            {...register(`${name}.street`)}
          />

          <input
            className="w-36"
            type="text"
            placeholder={I18n.t("js.forms.address.number")}
            aria-label={I18n.t("js.forms.address.number")}
            {...register(`${name}.number`)}
          />
        </div>
      </div>
      <div className="control-group">
        <Label
          label={`${I18n.t("js.forms.address.zip")} / ${I18n.t(
            "js.forms.address.city",
          )}`}
        />
        <div className="controls flex gap-2">
          <div className="w-36">
            <input
              type="text"
              pattern="[0-9]{5}(-[0-9]{4})?"
              maxLength={10}
              placeholder={I18n.t("js.forms.address.zip")}
              aria-label={I18n.t("js.forms.address.zip")}
              {...register(`${name}.zip`)}
            />
          </div>
          <input
            type="text"
            placeholder={I18n.t("js.forms.address.city")}
            aria-label={I18n.t("js.forms.address.city")}
            {...register(`${name}.city`)}
          />
        </div>
      </div>
      <div className="control-group">
        <Label label={I18n.t("js.forms.address.state")} />
        <div className="controls">
          <input
            type="text"
            placeholder={I18n.t("js.forms.address.state")}
            aria-label={I18n.t("js.forms.address.state")}
            {...register(`${name}.state`)}
          />
        </div>
      </div>
      <div className="control-group">
        <Label label={I18n.t("js.forms.address.country")} />
        <div className="controls">
          <input
            type="text"
            placeholder={I18n.t("js.forms.address.country")}
            aria-label={I18n.t("js.forms.address.country")}
            {...register(`${name}.country`)}
          />
        </div>
      </div>
    </div>
  );
}
